import { ZuiBaseElement } from '@zywave/zui-base';
import { html } from 'lit-html';
import '@zywave/zui-colors';

class ZuiToggleButton extends ZuiBaseElement {
  static get properties() {
    return {};
  }

  constructor() {
    super();
  }

  _renderStyle() {
    return html`
      <style>
        :host{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;vertical-align:middle}::slotted(zui-button){border-radius:0}::slotted(zui-button:first-of-type){border-bottom-left-radius:30px;border-top-left-radius:30px}::slotted(zui-button:last-of-type){border-top-right-radius:30px;border-bottom-right-radius:30px}
      </style>
    `;
  }

  render() {
    return html`
      ${this._renderStyle()} <slot></slot>
    `;
  }

}

customElements.define('zui-toggle-button', ZuiToggleButton);